export default __webpack_public_path__ + "static/media/text.b8b65b90.svg";